import {
  DownOutlined,
  KeyOutlined,
  LogoutOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Image,
  Input,
  Modal,
  Rate,
  Row,
  Tag,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import Logo from "../../assets/images/Logo.svg";
import notfound from "../../assets/images/not_found.png";
import apiPath from "../../constants/apiPath";
import NotificationPanel from "../notifications/NotificationPanel";
import { AuthContext } from "../../context/AuthContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import DeleteModal from "../DeleteModal";
import ViewAndEditProfile from "./ViewAndEditProfile";
// import ViewAndEditProfile from "./ViewAndEditProfile";

const { confirm } = Modal;

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ onPress, setToggle }) {
  const [visible, setVisible] = useState(false);
  const { userProfile, isAdmin, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [profile, setProfile] = useState({});
  const [selected, setSelected] = useState();
  const [profileVisible, setProfileVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [appSetting, setAppSetting] = useState({});
  const [appSettingSelected, setAppSettingSelected] = useState();
  const [appSettingVisible, setAppSettingVisible] = useState(false);
  const [payment, showPayment] = useState(false);
  const { request } = useRequest();
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const authRole = localStorage.getItem("authRole") || "admin";
  const storedProfile = (() => {
    try {
      return JSON.parse(localStorage.getItem("userProfile") || "null");
    } catch (_err) {
      return null;
    }
  })();
  const superAdminId =
    userProfile?._id ||
    userProfile?.id ||
    userProfile?.user_id ||
    userProfile?.bus_company_id ||
    userProfile?.airline_id ||
    profile?._id ||
    profile?.id ||
    profile?.user_id ||
    profile?.bus_company_id ||
    profile?.airline_id ||
    storedProfile?._id ||
    storedProfile?.id ||
    storedProfile?.user_id ||
    storedProfile?.bus_company_id ||
    storedProfile?.airline_id;

  const items = [
    {
      label: lang("editProfile"),
      key: "1",
      icon: <UserOutlined />,
      danger: true,
    },
    {
      label: lang("changePassword"),
      key: "2",
      icon: <KeyOutlined />,
      danger: true,
    },
    {
      label: lang("logout"),
      key: "3",
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  const [isRestaurantOnline, setIsRestaurantOnline] = useState();

  const handleChangeRestaurantStatus = () => {
    //TODO: add api
    request({
      url: apiPath.changeOnline,
      method: "PUT",
      onSuccess: (data) => {
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          setIsRestaurantOnline(data.data.is_online);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error, Severty.Error);
      },
    });
  };

  const showDeleteConfirm = (record) => {
    setIsLogoutModalVisible(true);
  };

  const handleMenuClick = (e) => {
    if (e.key == 2) {
      if (authRole === "hotel") {
        navigate("/change-password");
      } else if (authRole === "agent") {
        navigate("/agent-change-password");
      } else {
        setVisible(true);
      }
    }
    if (e.key == 1) {
      setProfileVisible(true);
      setRefresh((prev) => !prev);
    }
    if (e.key == 4) {
      setAppSettingVisible(true);
    }
    if (e.key == 3) {
      showDeleteConfirm();
    }
  };

  const handleCreate = (values) => {
    onCreate(values);
  };

  const onCreate = (values) => {
    const { old_password, new_password, confirm_password } = values;
    const payload = {};
    if (!old_password || !new_password || !confirm_password)
      return ShowToast("Please fill all password fields", Severty.ERROR);
    if (!superAdminId) {
      return ShowToast("Unable to identify admin profile", Severty.ERROR);
    }
    setLoading(true);
    payload.oldPassword = old_password;
    payload.password = new_password;
    payload.confirmPassword = confirm_password;

    request({
      // Api: POST /superAdmin_change_password/:superAdmin_id
      url: `${apiPath.superAdminChangePassword}/${superAdminId}`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status || data.success) {
          ShowToast(data.message || "Password changed successfully", Severty.SUCCESS);
          setVisible(false);
          form.resetFields();
        } else {
          ShowToast(data.message || "Failed to change password", Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(
          error?.response?.data?.message || "Failed to change password",
          Severty.ERROR,
        );
        setLoading(false);
      },
    });
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  useEffect(() => {
    setIsRestaurantOnline(userProfile?.is_online);
  }, [userProfile]);

  useEffect(() => {
    if (authRole !== "admin" && authRole !== "airline" && authRole !== "bus") {
      // Always read the latest data from localStorage so a just-saved profile image shows up
      const latestProfile = (() => {
        try {
          return JSON.parse(localStorage.getItem("userProfile") || "null");
        } catch (_e) {
          return null;
        }
      })();
      const merged = { ...(userProfile || {}), ...(latestProfile || {}) };
      setProfile(merged);
      setSelected(merged);

      // For agents, fetch profileImage from the bookings API if not already present
      if (authRole === "agent" && !merged.profileImage) {
        const agentId = merged.agent_id;
        if (agentId) {
          request({
            url: apiPath.agentBookingsByAgent(agentId),
            method: "GET",
            onSuccess: (data) => {
              const agentInfo = data?.agent;
              if (agentInfo?.profileImage) {
                const updated = { ...merged, profileImage: agentInfo.profileImage };
                setProfile(updated);
                setSelected(updated);
                // Persist so subsequent renders don't re-fetch
                try {
                  localStorage.setItem("userProfile", JSON.stringify(updated));
                } catch (_e) { }
              }
            },
            onError: () => { },
          });
        }
      }
      return;
    }
    if (!superAdminId) return;
    request({
      url: `${apiPath.getSuperAdmin}/${superAdminId}`,
      method: "GET",
      onSuccess: (data) => {
        const resolvedUser =
          data?.details?.[0] || data?.data?.details?.[0] || data?.data || data?.user || null;
        if (data?.status || data?.success) {
          setProfile(resolvedUser || {});
          setSelected(resolvedUser || {});
        }
      },
      onError: (error) => {
        console.error("Failed to fetch profile:", error);
      },
    });
  }, [refresh, authRole, superAdminId, userProfile]);

  useEffect(() => {
    if (!isOpen) {
      document.body.classList.remove("edit-dropdown");
      return;
    }
    document.body.classList.add("edit-dropdown");

    return () => {
      document.body.classList.remove("edit-dropdown");
    };
  }, [isOpen]);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  // useEffect(() => {
  //   if (!!userProfile && userProfile.user_language) {
  //     localStorage.setItem("languageSet", userProfile.user_language);
  //   }
  // }, [userProfile]);

  // Removed notification fetching - showing "Coming Soon" instead

  // Removed GetWallet call - not needed
  // useEffect(() => {
  //   if (!!userProfile) {
  //     GetWallet();
  //   }
  // }, [userProfile]);

  return (
    <>
      <Row>
        <Col span={24}>
          {/* Removed wallet balance check - not needed for time tracker */}
          {/* {wallet?.balance < 0 ? (
            <div className="">
              <div className="  online-swich-header">
                <p>
                  {lang(
                    "Please add funds to your wallet as your balance is currently low"
                  )}
                </p>
                <Button
                  className=" top-btn-header"
                  onClick={() => showPayment(true)}
                >
                  {lang("Top Up")}
                </Button>
              </div>
            </div>
          ) : null} */}
        </Col>
      </Row>
      <Row gutter={[24, 0]} className="justify-content-between mx-0">
        <Col
          span={24}
          xs={24}
          md={24}
          sm={24}
          lg={12}
          className="SectionMain px-0"
        >
          <div className="toggale-headr">
            <div className="d-flex align-items-center gap-2 ">
              <Button
                type="link"
                className="sidebar-toggler ps-0 d-none d-lg-block"
                onClick={() => setToggle()}
              >
                {toggler}
              </Button>
              <div className="d-none d-lg-block">
              <h4 className="mb-0" style={{ fontSize: "18px", fontWeight: "600" }}>
                Welcome, {storedProfile?.name || userProfile?.name || "Admin"}
              </h4>
              </div>
            </div>
          </div>
          <div className="tabLogo d-block d-lg-none ">
            <div
              className="logoImg"
              style={{
                width: 45,
                height: 45,
                // borderRadius: "50%",
                // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
              }}
            >
              {/* <SafetyCertificateOutlined style={{ fontSize: 24, color: "#fff" }} /> */}
            </div>
          </div>
        </Col>
        <Col span={24} xs={24} sm={24} lg={12} className="header-control px-0">
          <Button
            type="link"
            className="sidebar-toggler ps-0"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>

          {/* <div className="notificationDropdownMain">
            <div className="notification-header d-lg-block">
              <NotificationPanel />
            </div>
          </div> */}

          <div className="profileDropdownMain">
            <Dropdown
              open={isOpen}
              onOpenChange={(open) => setIsOpen(open)}
              className="edit-box"
              menu={menuProps}
              trigger={["click"]}
            >
              <Button className="ant-btn ant-btn-default ant-dropdown-trigger ant-dropdown-open">
                <div className=" d-flex align-items-center gap-2">
                  <div className="userImg">
                    {console.log(profile?.profileImage || profile?.image || userProfile?.profileImage || userProfile?.image ||selected?.profileImage || notfound)}
                    <Image
                      src={profile?.profileImage || profile?.image || userProfile?.profileImage || userProfile?.image ||selected?.profileImage || notfound}
                      preview={false}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />  
                  </div>
                  <div className="d-none d-xl-block">
                    <div className="userName">
                      {profile?.name || userProfile?.name || "Administrator"}
                      <DownOutlined />
                    </div>
                  </div>
                </div>
              </Button>
            </Dropdown>
          </div>
        </Col>
      </Row>

      {isLogoutModalVisible && (
        <DeleteModal
          title={lang("Logout")}
          subtitle={lang("Are you sure you want to Logout the Application?")}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => logout()}
          okText={lang("logout")}
          dangerOk={false}
        />
      )}

      {profileVisible && (
        <ViewAndEditProfile
          show={profileVisible}
          hide={() => {
            setProfileVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      {appSettingVisible && (
        <AppSetting
          show={appSettingVisible}
          hide={() => {
            setAppSettingVisible(false);
          }}
          data={appSettingSelected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {visible && (
        <ChangePassword
          show={visible}
          hide={() => setVisible(false)}
          handleCreate={handleCreate}
          loading={loading}
        />
      )}
    </>
  );
}

const ChangePassword = ({ handleCreate, hide, show, loading }) => {
  const [formChange] = Form.useForm();

  return (
    <Modal
      open={show}
      // title="Change password"
      okText="Ok"
      onCancel={hide}
      //onOk={handleCreate}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 className="modal_title_cls">{lang("Change Password")}</h4>
      <Form
        id="create"
        form={formChange}
        onFinish={handleCreate}
        layout="vertical"
      >
        <Form.Item
          label={lang("Old Password")}
          name="old_password"
          hasFeedback
          rules={[
            { required: true, message: lang("Please enter the old password!") },
          ]}
        >
          <Input.Password placeholder="Enter old password" />
        </Form.Item>
        <Form.Item
          label={lang("New Password")}
          name="new_password"
          dependencies={["old_password"]}
          hasFeedback
          rules={[
            { required: true, message: lang("Please enter the new password!") },
            {
              pattern: new RegExp(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/,
              ),
              message:
                "New password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("old_password") === value) {
                  return Promise.reject(
                    new Error(
                      lang("Old password & new password must be different"),
                    ),
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password placeholder="Enter new password" />
        </Form.Item>
        <Form.Item
          label={lang("Confirm New Password")}
          name="confirm_password"
          dependencies={["new_password"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: lang("Please enter the confirm password!"),
            },
            {
              pattern: new RegExp(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/,
              ),
              message:
                "Confirm password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Confirm password & password does not match!"),
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const AppSetting = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
  }, [data]);

  const onAppSetting = (values) => {
    setLoading(true);
    request({
      url: apiPath.updateAppSetting,
      method: "POST",
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      width={1200}
      visible={show}
      title={`${data ? "Update App Setting" : ""}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onAppSetting} layout="vertical">
        <Row gutter={{ xs: [0, 16], md: [16, 0] }}>
          <Col span={24} md={12}>
            <Card title="Android Details">
              <Col span={24}>
                <Form.Item
                  label="App Store URL"
                  name="app_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the app store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter App Store URL" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Version"
                  name="android_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter Android Version" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Share Content"
                  name="android_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share Android Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>

          <Col span={24} md={12}>
            <Card title="IOS Details">
              <Col span={24} className="">
                <Form.Item
                  label="Play Store URL"
                  name="play_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the play store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter Play Store URL" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Version"
                  name="ios_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter IOS Version" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Share Content"
                  name="ios_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share IOS Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Header;
